import { render } from "./SocialNews.vue?vue&type=template&id=615a6dc9"
import script from "./SocialNews.vue?vue&type=script&lang=js"
export * from "./SocialNews.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PROJECT\\Mbf5_HCC\\XaTanHungHph\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__